<script setup lang="ts">
import { useComponentClasses } from "../../composables";

interface ModalBodyProps {
  /** Convenience prop to add padding to the bottom of the body */
  paddingBottom?: boolean;
  /** Convenience prop to add padding to the top of the body */
  paddingTop?: boolean;
}

const { paddingBottom = false, paddingTop = false } = defineProps<ModalBodyProps>();

const { root } = useComponentClasses("ui-modal-body");

const rootClass = root({
  modifiers: {
    "padding-bottom": paddingBottom,
    "padding-top": paddingTop,
  },
});
</script>

<template>
  <div :class="rootClass">
    <slot />
  </div>
</template>

<style scoped>
.ui-modal-body {
  flex: 1 1 auto;
  overflow-y: auto;
  /* 4px gives us a buffer for any elements with a focus ring so that the halo is not clipped */
  padding: 0 var(--_padding-x) 4px var(--_padding-x);
}

.ui-modal-body--padding-top {
  padding-top: var(--_padding-y);
}

.ui-modal-body--padding-bottom {
  padding-bottom: var(--_padding-y);
}
</style>
